import React, { FunctionComponent, ReactNode } from 'react';
import GroupsTableWrapper from '../../../shared/groups-table';

interface IssuerGroupsPermissionsTableProps {
  title?: ReactNode;
  filters?: ReactNode;
  skipFilterUrlSync?: boolean;
  forceDataLoad?: boolean;
  setForceDataLoad?: (val: boolean) => void;
  hasPermission: boolean;
  setFilterPopupHeight?: (height: number) => void;
}

const IssuerGroupsPermissionsTable: FunctionComponent<IssuerGroupsPermissionsTableProps> = ({
  hasPermission,
  filters,
  setFilterPopupHeight,
  ...restProps
}) => {
  return <GroupsTableWrapper hasPermission={hasPermission} showOrganizationColumn={true} {...restProps} />;
};

export default IssuerGroupsPermissionsTable;
